module.exports = __webpack_public_path__ + "img/amenazas.5b4655d5.png";